import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="pt-16 md:pt-18 min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center px-4">
          <div className="font-heading text-8xl md:text-9xl font-bold text-accent-200 mb-4">404</div>
          <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            页面未找到
          </h1>
          <p className="text-foreground-600 text-sm md:text-base mb-8 max-w-md mx-auto">
            您访问的页面可能已被移除或地址有误。请检查网址或返回首页。
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-lg bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            <i className="ri-home-line"></i>
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}